<template>
  <div class="review-list-cont online-studyEvaluate review-record" style="overflow-y: unset;">
    <div class="train-Switch-box">
      <div class="train-Switch">
        <div class="switch-left">
          <div class="tabs">
            <span class="color-333">{{$store.state.globalTxt.examin3?$store.state.globalTxt.examin3:$t('Evaluation.record')}}</span>
          </div>
        </div>
        <div class="switch-right">
          <em class="icon" @click="$router.go(-1);"></em>
        </div>
      </div>
    </div>
    <EmptyTip v-if="recordList.length <= 0 && loadFinish" :emptyTip="$t('Evaluation.dearChild')" />
    <template v-else>
      <ScrollBox :list="recordList" @getData="getData">
        <div class="evaluation-record">
          <div class="item" v-for="(item,index) of recordList" :key="index">
            <div class="item-left">
              <span>{{item.examine_name}}</span>
              <span>{{item.examine_createtime}}</span>
            </div>
            <div class="item-center">
              <img src="@/assets/images/studyCenter/Evaluation/reword.png" alt class="icon" />
              <span class="score">{{item.examine_score}}</span>
            </div>
            <div class="item-right">
              <span
                class="bg-base1 bg-base1-shadow cursor"
                v-if="item.has_analysis==1"
                @click="abiltyClick(item.examine_branch,item.examine_name)"
              >{{$t('Evaluation.ability')}}</span>
              <span
                class="bg-base btnShadow cursor"
                @click="paperClick(item.examine_branch,item.examine_name)"
              >{{$store.state.currentChild.class_genre == 'school'?$t('Evaluation.questionTitle'):$t('Evaluation.myReport')}}</span>
            </div>
          </div>
        </div>
      </ScrollBox>
    </template>
  </div>
</template>

<script>
import evaluationStore from "@/views/StudyCenter/Evaluation/Evaluation";
import ScrollBox from "@/components/ScrollBox";
import EmptyTip from "@/components/Empty";
export default {
  name: "record",
  components: {
    ScrollBox,
    EmptyTip
  },
  data() {
    return {
      studentInfo: {
        token: "",
        member_id: "",
        student_id: "", //学生ID
        examine_branch: "" //检测编号
      },

      canLoad: true,
      isLoading: false,
      loadFinish: false,
      pageData: {
        p: 1,
        num: 10
      },
      textbook_id: "",
      recordList: [],
      recordListLength: 0
    };
  },
  mounted() {},
  updated() {},
  created() {
    this.studentInfo.token = this.$store.state.token;
    this.studentInfo.member_id = this.$store.state.member_id;
    this.studentInfo.student_id = this.$store.state.currentChild.student_id;
    this.studentInfo.classcode_branch = this.$store.state.currentChild.classcode_branch; //班别编号
    this.textbook_id = this.$route.query.textbook_id;
    this.getExamHistory();
  },
  watch: {},
  computed: {},
  methods: {
    getData() {
      console.log("getData");
      if (!this.isLoading && this.canLoad) {
        this.getExamHistory();
      }
    },
    //获取 测评 题目问题详情
    getExamHistory() {
      if (this.canLoad) {
        this.isLoading = true;
        this.$store.dispatch("setLoadingStatus", true);
        evaluationStore
          .getExamHistory({
            token: this.studentInfo.token, //登陆获取token
            member_id: this.studentInfo.member_id, //登陆获取的会员表
            student_id: this.studentInfo.student_id,
            classcode_branch: this.studentInfo.classcode_branch,
            textbook_id: this.textbook_id,
            num: this.pageData.num,
            p: this.pageData.p
          })
          .then(res => {
            console.log(typeof res.data.result)
            console.log(res.data.result.length)
            if (res.data.result.length == undefined) {
              if (res.data.result.list.length < this.pageData.p) {
                this.canLoad = false;
              }
              let list = res.data.result.list
               list.forEach((element, index) => {
                element.examine_createtime = this.timestampToTime(element.examine_createtime)
              });
              this.recordList = this.recordList.concat(res.data.result.list);
              this.recordListLength = 1;
            } else {
              this.canLoad = false;
              this.recordList = this.recordList.concat([]);
              this.recordListLength = 0;
            }
            ++this.pageData.p;
            this.isLoading = false;
            this.loadFinish = true;
            this.$store.dispatch("setLoadingStatus", false);
          });
      }
    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate()<10 ? "0": date.getDate() + " ";
      var h = date.getHours() + ":";
      var m = date.getMinutes()<10 ? `0${date.getMinutes()}:`: `${date.getMinutes()}:`;
      var s = date.getSeconds()<10 ? `0${date.getDate()}`: date.getSeconds();
      return Y + M + D + h + m + s;
    },
    //能力分析
    abiltyClick(brand, name) {
      this.$router.push({
        path: "/studyEvaluate/ablityAnalyse",
        query: {
          examine_branch: brand,
          examine_name: escape(name)
        }
      });
    },
    //考卷分析
    paperClick(brand, name) {
      this.$router.push({
        path: "/studyEvaluate/wrongAnalysis",
        query: {
          examine_branch: brand,
          examine_name: escape(name)
        }
      });
    }
  }
};
</script>

<style lang="less">
.review-record {
  #page-scroll-box {
    height: calc(100% - 70px);
  }
}

.evaluation-record {
  padding: 20px 35px;

  .item {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 0px 0px rgba(238, 238, 238, 1);
    border-radius: 8px;
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    position: relative;

    .item-left {
      span {
        font-size: 12px;
        color: #aaaaaa;
        display: block;
        max-width: 70%;

        &:first-child {
          color: #333333;
          font-size: 16px;
          margin-bottom: 5px;
        }
      }
    }

    .item-center {
      // position: relative;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      img {
        height: 68px;
        height: 68px;
      }

      .icon {
      }

      .score {
        position: absolute;
        left: 49%;
        top: 40%;
        transform: translate(-50%, -50%);
        color: #ffffff;
        font-size: 18px;
        font-weight: bold;
      }
    }

    .item-right {
      span {
        padding: 10px 15px;
        color: #ffffff;
        border-radius: 112px;
        font-size: 14px;

        &:last-child {
          margin-left: 15px;
        }
      }
    }
  }
}
</style>
